import {useFetchProfilePageProjectsByIDsQuery} from '../../generated/graphql';
import {ProjectData} from '../EntityPage';

function exists<T>(value: T | null | undefined): value is T {
  return !!value;
}

export function projectsFromShowcasedProjectsQueryResult(
  result: ReturnType<typeof useFetchProfilePageProjectsByIDsQuery>
): ProjectData[] {
  if (result.loading) {
    return [];
  }

  if (result.data == null || result.data.projects == null) {
    return [];
  }

  const showcasedProjects = result.data.projects.edges.map(p => {
    if (p == null || p.node == null) {
      return null;
    }
    return {
      id: p.node.id,
      name: p.node.name,
      entityName: p.node.entityName,
      user: p.node.user ?? {},
      runCount: p.node.runCount ?? 0,
      lastActive: p.node.lastActive,
      access: p.node.access ?? '',
    };
  });

  return showcasedProjects.filter(exists);
}
